import {
  AllergySegmentationIds,
  NutritionSegmentationIds,
} from 'constants/segmentation';
import { possibleTags } from 'interfaces/collection-filter';

interface PetProfileTextParams {
  selectedAge?: string;
  selectedBreed?: string;
  selectedNeeds?: string[];
  selectedAllergies?: string[];
  formatMessage: (message: { id: string }) => string;
}

/**
 * Utility function that returns a translated string with the pet profile attributes.
 */
export const getPetProfileText = ({
  selectedAge,
  selectedBreed,
  selectedNeeds,
  selectedAllergies,
  formatMessage,
}: PetProfileTextParams): string => {
  const texts: string[] = [];

  if (selectedAge) {
    texts.push(
      formatMessage({ id: `landingpage:need-capture:age:${selectedAge}` })
    );
  }

  if (selectedBreed) {
    texts.push(
      formatMessage({ id: `landingpage:need-capture:breed:${selectedBreed}` })
    );
  }

  if (selectedNeeds && selectedNeeds.length > 0) {
    selectedNeeds.forEach((need) => {
      if (
        need === NutritionSegmentationIds.Intolerance &&
        selectedAllergies &&
        selectedAllergies.length > 0
      ) {
        const allergiesText = selectedAllergies
          .map((allergy) =>
            formatMessage({
              id: `common:allergy:${allergy}`,
            })
          )
          .join(', ');

        texts.push(
          formatMessage({
            id: `landingpage:need-capture:need:option:${need}`,
          }) + `: ${allergiesText}`
        );
      } else {
        texts.push(
          formatMessage({
            id: `landingpage:need-capture:need:option:${need}`,
          })
        );
      }
    });
  }

  return texts.join(', ');
};

/**
 * Utility function that maps the pet profile allergies to the segmentation ids.
 */
export const mapAllergyTagsToSegmentationIds = (
  tags: possibleTags[] | undefined
): AllergySegmentationIds[] | undefined => {
  if (!tags) return undefined;

  const mapping: { [key in possibleTags]?: AllergySegmentationIds } = {
    getreidefrei: 'grain-free',
    rind: 'beef',
    huhn: 'chicken',
    ente: 'duck',
    fisch: 'fish',
    kartoffel: 'potato',
    lamm: 'lamb',
    pferd: 'horse',
    ziege: 'goat',
    suskartoffel: 'sweet-potato',
  };

  return tags
    .map((tag) => mapping[tag])
    .filter((id): id is AllergySegmentationIds => id !== undefined);
};
